import "./App.css";
import {
  App as KonstaApp,
  Navbar,
  Tabbar,
  TabbarLink,
  Icon,
  Page,
  Popup,
} from "konsta/react";
import { useState } from "react";
import Home from "./features/home-tab/Home";
import Equipment from "./features/equipment-tab/Equipment";
import Lights from "./features/lights-tab/Lights";
import { useAppSelector, useAppDispatch } from "./app/hooks";
import { appSlice } from "./app/appSlice";
import Brightness from "./features/light-brightness/Brightness";
import ColorList from "./features/light-colors/ColorList";
import CustomColor from "./features/light-colors/CustomColor";
import Alexa from "./features/alexa/Alexa";

function AppContent() {
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState("tab-3");
  const editingLightBrightness = useAppSelector(
    (state) => state.app.editingLightBrightness
  );
  const editingLightColor = useAppSelector(
    (state) => state.app.editingLightColor
  );
  const editingCustomLightColor = useAppSelector(
    (state) => state.app.editingCustomLightColor
  );
  const alexaInterface = useAppSelector((state) => state.app.alexaInterface);
  const inIFrame = window.parent !== window;
  if (window.location.href.includes("safe-areas")) {
    const html = document.documentElement;
    if (html) {
      html.style.setProperty("--k-safe-area-top", "44px");
      html.style.setProperty("--k-safe-area-bottom", "34px");
    }
  }
  return (
    <KonstaApp theme="ios" safeAreas={!inIFrame}>
      {alexaInterface ? (
        <Alexa />
      ) : (
        <Page>
          <Navbar
            title="My Backyard"
            colors={{ bgIos: "bg-blue-trim", textIos: "text-white" }}
            large={true}
            translucent={false}
          />
          <Tabbar
            labels={true}
            icons={true}
            translucent={false}
            colors={{ bgIos: "bg-blue-trim" }}
            className="left-0 bottom-0 fixed"
          >
            <TabbarLink
              colors={{ textIos: "text-white/50", textActiveIos: "text-white" }}
              active={activeTab === "tab-1"}
              onClick={() => setActiveTab("tab-1")}
              icon={
                <Icon
                  ios={
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 23 20"
                      className="h-7"
                      style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "2",
                      }}
                    >
                      <g transform="matrix(1,0,0,1,-49.75,-849.25)">
                        <g id="TabBar-Icons">
                          <path
                            id="home"
                            d="M72.25,858.938C72.25,858.664 72.133,858.391 71.898,858.195L61.625,849.445C61.43,849.328 61.234,849.25 61,849.25C60.805,849.25 60.531,849.328 60.375,849.484L50.063,858.234C49.828,858.43 49.75,858.703 49.75,858.938C49.75,859.602 50.258,859.875 50.688,859.875C50.883,859.875 51.117,859.797 51.273,859.641L52.25,858.82L52.25,867.688C52.25,868.586 52.914,869.25 53.813,869.25L57.523,869.25C58.383,869.25 59.047,868.586 59.047,867.688L59.047,863L62.758,863L62.758,867.688C62.836,868.586 63.539,869.25 64.398,869.25L68.109,869.25C68.969,869.25 69.633,868.586 69.633,867.688L69.633,858.859L70.688,859.68C70.883,859.836 71.078,859.875 71.313,859.875C71.703,859.875 72.25,859.562 72.25,858.938ZM67.836,867.375L64.711,867.375L64.711,862.688C64.711,861.828 64.008,861.125 63.188,861.125L58.813,861.125C57.914,861.125 57.25,861.828 57.25,862.688L57.25,867.375L54.125,867.375L54.125,857.375C54.125,857.336 54.086,857.297 54.086,857.258L61,851.438L67.836,857.258L67.836,867.375Z"
                            style={{
                              fill: "currentColor",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                      </g>
                    </svg>
                  }
                />
              }
              label={"Home"}
            />
            <TabbarLink
              colors={{ textIos: "text-white/50", textActiveIos: "text-white" }}
              active={activeTab === "tab-2"}
              onClick={() => setActiveTab("tab-2")}
              icon={
                <Icon
                  ios={
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 25 25"
                      className="h-7"
                      style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "2",
                      }}
                    >
                      <g transform="matrix(1,0,0,1,-175.999,-758.998)">
                        <g id="Frame-43">
                          <g id="Frame">
                            <clipPath id="_clip1">
                              <rect x="176" y="759" width="24" height="24" />
                            </clipPath>
                            <g clipPath="url(#_clip1)">
                              <path
                                id="Vector"
                                d="M199.784,764.367C199.679,763.922 199.333,763.57 198.894,763.447C198.448,763.324 197.974,763.447 197.645,763.775L194.652,766.767L192.577,766.421L192.232,764.347L195.226,761.353C195.548,761.031 195.677,760.55 195.554,760.111C195.431,759.665 195.074,759.319 194.628,759.208C192.203,758.611 189.688,759.302 187.911,761.072C186.134,762.849 185.464,765.417 186.102,767.817L177.041,776.878C175.652,778.267 175.652,780.529 177.041,781.917C177.709,782.63 178.606,783 179.562,783C180.511,783 181.401,782.631 182.075,781.957L191.127,772.905C193.571,773.55 196.138,772.87 197.919,771.083C199.695,769.27 200.394,766.8 199.784,764.367ZM196.859,770.025C195.371,771.513 193.185,772.023 191.15,771.344L190.71,771.197L180.973,780.895C180.194,781.675 178.841,781.675 178.061,780.895C177.258,780.092 177.258,778.78 178.061,777.977L187.764,768.274L187.658,767.841C186.984,765.802 187.488,763.616 188.97,762.131C190.037,761.07 191.443,760.496 192.897,760.496C193.219,760.496 193.547,760.526 193.869,760.578L190.623,763.83L191.267,767.721L195.164,768.372L198.41,765.12C198.73,766.917 198.162,768.727 196.859,770.025ZM179.749,778.458C179.333,778.458 178.999,778.792 178.999,779.208C178.999,779.624 179.333,779.958 179.749,779.958C180.166,779.958 180.499,779.624 180.499,779.208C180.499,778.792 180.165,778.458 179.749,778.458Z"
                                style={{
                                  fill: "currentColor",
                                  fillRule: "nonzero",
                                }}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  }
                />
              }
              label={"Equipment"}
            />
            <TabbarLink
              colors={{ textIos: "text-white/50", textActiveIos: "text-white" }}
              active={activeTab === "tab-3"}
              onClick={() => setActiveTab("tab-3")}
              icon={
                <Icon
                  ios={
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 14 20"
                      className="h-7"
                      style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "2",
                      }}
                    >
                      <g transform="matrix(1,0,0,1,-308.125,-761)">
                        <g id="TabBar-Icons_2">
                          <path
                            id="lightbulb"
                            d="M311.875,778.773C311.875,779.008 311.914,779.242 312.07,779.438L312.734,780.453C312.93,780.766 313.398,781 313.789,781L316.172,781C316.562,781 317.031,780.766 317.227,780.453L317.891,779.438C318.008,779.281 318.086,778.969 318.086,778.773L318.125,777.25L311.875,777.25L311.875,778.773ZM315,761C311.016,761.039 308.125,764.242 308.125,767.875C308.125,769.594 308.75,771.156 309.805,772.367C310.469,773.109 311.445,774.672 311.836,775.961L311.836,776L318.125,776L318.125,775.961C318.516,774.672 319.492,773.109 320.156,772.367C321.211,771.195 321.875,769.633 321.875,767.875C321.875,764.086 318.789,761.039 315,761ZM318.75,771.195C318.125,771.859 317.383,772.992 316.836,774.125L313.125,774.125C312.578,772.992 311.836,771.859 311.211,771.195C310.43,770.258 310,769.086 310,767.875C310,765.453 311.875,762.914 314.961,762.875C317.734,762.875 320,765.141 320,767.875C320,769.086 319.531,770.258 318.75,771.195ZM314.375,764.125C312.617,764.125 311.25,765.531 311.25,767.25C311.25,767.602 311.523,767.875 311.875,767.875C312.188,767.875 312.5,767.602 312.5,767.25C312.5,766.234 313.32,765.375 314.375,765.375C314.688,765.375 315,765.102 315,764.789C315,764.438 314.688,764.125 314.375,764.125Z"
                            style={{
                              fill: "currentColor",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                      </g>
                    </svg>
                  }
                />
              }
              label={"Lights"}
            />
          </Tabbar>
          {activeTab === "tab-1" ? <Home></Home> : null}
          {activeTab === "tab-2" ? <Equipment></Equipment> : null}
          {activeTab === "tab-3" ? <Lights></Lights> : null}
          <Popup
            opened={editingLightBrightness}
            onBackdropClick={() =>
              dispatch(appSlice.actions.setEditingLightBrightness(null))
            }
          >
            {!!editingLightBrightness ? (
              <Brightness
                editingLightBrightness={editingLightBrightness}
              ></Brightness>
            ) : null}
          </Popup>
          <Popup
            opened={editingLightColor}
            onBackdropClick={() =>
              dispatch(appSlice.actions.setEditingLightColor(null))
            }
          >
            {!!editingLightColor ? (
              <ColorList editingLightColor={editingLightColor}></ColorList>
            ) : null}
          </Popup>
          <Popup
            opened={editingCustomLightColor}
            onBackdropClick={() =>
              dispatch(appSlice.actions.setEditingCustomLightColor(null))
            }
          >
            {!!editingCustomLightColor ? (
              <CustomColor
                editingCustomLightColor={editingCustomLightColor}
              ></CustomColor>
            ) : null}
          </Popup>
        </Page>
      )}
    </KonstaApp>
  );
}

export default AppContent;
